var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.snackbarClass,style:({ minWidth:_vm.minwidth+'%',  top:_vm.topalign+'px', backgroundColor:_vm.backgroundColor, right:_vm.rightalign,  left:_vm.leftalign+'%' })},[_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59ee7cc9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Snackbar.vue
// module id = 209
// module chunks = 309